import React, { useMemo } from 'react';
import VoxelTooltipShort from '../../../components/voxel/Tooltip/VoxelTooltipShort';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { getEmojiFlag } from '../../../logic/otherUtilities/getEmojiFlag';
import { useProjectDefaults } from '../../../logic/otherUtilities/useProjectDefaults';
import { ProjectSettingsMenuChoices } from '../../ProjectSettingsPage/ProjectSettingsPage';
import { ProjectTabChoices } from '../ProjectPage';
import GotToEditLink from './GotToEditLink';

export interface LocationIndicatorProps {
  project: ProjectGq;
}

export const LocationIndicator: React.FC<LocationIndicatorProps> = ({ project }) => {
  // Project settings
  const projectDefaults = useProjectDefaults(project);
  const mixedLocation = project.serpLocationId !== project.defaultLocationId;

  // Get serp location name
  const serpLocationIsCity = !!projectDefaults?.serpCity?.id;
  const serpLocationName = serpLocationIsCity
    ? projectDefaults?.serpCity?.name
    : getEmojiFlag(projectDefaults?.serpCountry?.countryCode);

  // Get keyword location name
  const keywordLocationIsCity = !!projectDefaults?.volumeCity?.id;
  let keywordLocationName = projectDefaults?.volumeCountry
    ? getEmojiFlag(projectDefaults.volumeCountry.countryCode)
    : 'Global';
  if (keywordLocationIsCity) {
    keywordLocationName += ' ' + projectDefaults?.volumeCity?.name;
  }

  // Get final presented name
  let presentedLocationName = keywordLocationName;
  if (mixedLocation) {
    presentedLocationName += ` ${serpLocationName}`;
  }

  // SERP validation
  const serpLocationRequired = useMemo(
    () => !projectDefaults?.volumeCountry?.name && !projectDefaults?.serpCountry?.name,
    [projectDefaults]
  );

  // URL
  const settingsUrl = `/${project.id}/${ProjectTabChoices.Settings}/${ProjectSettingsMenuChoices.DataCollectionSettings}#location`;

  if (!projectDefaults) {
    return <></>;
  }

  return (
    <VoxelTooltipShort message="Edit keyword location">
      <GotToEditLink href={settingsUrl} hasError={serpLocationRequired} className="h-7">
        {presentedLocationName}
      </GotToEditLink>
    </VoxelTooltipShort>
  );
};

export default LocationIndicator;
